import(/* webpackMode: "eager" */ "/codebuild/output/src3695159427/src/app/(dashboard)/page.js");
